import React from "react";

const ForbiddenAccessPage = () => {
  return <div>Forbidden Access</div>;
};

export default ForbiddenAccessPage;
